"use strict";
// @ts-ignore
try {
    self['workbox:expiration:7.2.0'] && _();
}
catch (e) { }
